$milis_skills $mol_book2_catalog
	menu_title \Gen Умения
	param \page
	menu_foot /
		<= Person_id $mol_text text <= person_id \
		<= Sources $mol_link_source
			uri \https://github.com/Lyumih/milis/tree/main/skills
	spreads *
		skills <= Skills_page $milis_skills_skill_page
		games <= Games_page $milis_skills_game_page
	



